import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiError } from "../lib/api";
import { Zap, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("chaz50000@googlemail.com");
  const [password, setPassword] = useState("Momento2026!");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background relative z-10">
      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-md animate-fade-up">
          <div className="flex items-center gap-2.5 mb-10">
            <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center">
              <Zap className="w-5 h-5 text-primary-foreground" />
            </div>
            <span className="text-2xl font-display font-extrabold tracking-tight">Momento</span>
          </div>
          <h1 className="text-3xl font-display font-bold tracking-tight mb-1.5">Sign in</h1>
          <p className="text-muted-foreground mb-8 text-sm">Your all-in-one marketing OS awaits.</p>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input" required autoComplete="email" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input" required autoComplete="current-password" />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
            <Button type="submit" className="w-full h-11 font-semibold transition-transform hover:scale-[1.01] active:scale-[0.99]"
              disabled={loading} data-testid="login-submit-button">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
            </Button>
          </form>
          <p className="text-sm text-muted-foreground mt-6">
            New agency? <Link to="/register" className="text-primary font-medium hover:underline" data-testid="go-register-link">Create an account</Link>
          </p>
        </div>
      </div>
      <div className="hidden lg:flex flex-col justify-between p-12 relative overflow-hidden"
        style={{ background: "linear-gradient(140deg, #111827 0%, #090D16 60%)" }}>
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full blur-3xl opacity-20"
          style={{ background: "hsl(var(--primary))" }} />
        <div className="relative z-10">
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">The Agency Operating System</p>
          <h2 className="text-4xl font-display font-extrabold leading-tight max-w-md">
            Run every client. From one command center.
          </h2>
        </div>
        <div className="relative z-10 grid grid-cols-3 gap-4">
          {["Unified CRM", "Visual Automations", "White-Label"].map((f) => (
            <div key={f} className="glass rounded-xl p-4">
              <p className="text-sm font-semibold">{f}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
